import { useState, useEffect } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import ProjectProfile from "../components/ProjectProfile";
import projectData from "../data/projectData";
import { primaryBtn, templatePageDiv } from "../styles/style";
import SectionHeader from "../components/SectionHeader";

const Project = () => {
  const dataLen = projectData().length;
  const [idx, setIdx] = useState(1);
  const [projectInfo, setProjectInfo] = useState([
    projectData()[0],
    projectData()[1],
  ]);

  const rightArrowHandler = () => {
    idx + 2 <= dataLen - 1 ? setIdx(idx + 2) : setIdx(1);
  };

  const leftArrowHandler = () => {
    idx - 2 >= 1 ? setIdx(idx - 2) : setIdx(dataLen - 1);
  };

  useEffect(() => {
    setProjectInfo([projectData()[idx - 1], projectData()[idx]]);
  }, [idx]);

  return (
    <ProjectPage id="project">
      <SectionHeader title={"PROJECTS"} />
      {projectInfo && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 1,
          }}
          key={projectInfo[1].index}
        >
          <ProjectProfile
            firstName={projectInfo[0].name}
            firstDesc={projectInfo[0].desc}
            firstButtonName={projectInfo[0].linkName}
            firstLink={projectInfo[0].link}
            firstImg1={projectInfo[0].img1}
            firstImg2={projectInfo[0].img2}
            secondName={projectInfo[1].name}
            secondDesc={projectInfo[1].desc}
            secondButtonName={projectInfo[1].linkName}
            secondLink={projectInfo[1].link}
            secondImg1={projectInfo[1].img1}
            secondImg2={projectInfo[1].img2}
            key={projectInfo[1].index}
          />
        </motion.div>
      )}

      <ButtonContainer>
        <div className="shell ">
          <div className="buttons">
            <ArrowBtn onClick={leftArrowHandler}> {"<"} </ArrowBtn>

            <ArrowBtn onClick={rightArrowHandler}>
              <p>{">"}</p>
            </ArrowBtn>
          </div>
        </div>
      </ButtonContainer>
    </ProjectPage>
  );
};

export default Project;

const ProjectPage = styled(templatePageDiv)`
  background: #0c0c0c;
  padding: 3rem 0rem;

  @media (min-width: 1600px) {
    min-height: 100vh;
  }
`;

const ButtonContainer = styled(motion.div)`
  width: 100%;
  display: block;
  @media (min-width: 1600px) {
    width: 100rem;
  }

  .buttons {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 4rem;

    @media (max-width: 900px) {
      margin: 2rem 0rem;
    }
  }
`;

const ArrowBtn = styled(primaryBtn)`
  padding: 0rem 1rem;
  display: flex;
  font-family: "Reggae One", cursive;
  align-items: center;
  padding-bottom: 0.3rem;
  font-size: 0.7rem;
  padding-bottom: 0.2rem;
  p {
    margin: 0;
    padding: 0;
    text-align: center;
  }
`;
